import _extends from "babel-runtime/helpers/extends";
import { /*extractPath, */wrapSelectors } from "@rosetta/redux-utils";

export var SRE_SHOW_SILENCE_MODAL = "SRE_SHOW_SILENCE_MODAL";
export var SRE_HIDE_SILENCE_MODAL = "SRE_HIDE_SILENCE_MODAL";

export var SRE_SHOW_TOO_LOUD_MODAL = "SRE_SHOW_TOO_LOUD_MODAL";
export var SRE_HIDE_TOO_LOUD_MODAL = "SRE_HIDE_TOO_LOUD_MODAL";

export var SRE_SHOW_TOO_SOFT_MODAL = "SRE_SHOW_TOO_SOFT_MODAL";
export var SRE_HIDE_TOO_SOFT_MODAL = "SRE_HIDE_TOO_SOFT_MODAL";

export var SRE_SHOW_TOO_NOISY_MODAL = "SRE_SHOW_TOO_NOISY_MODAL";
export var SRE_HIDE_TOO_NOISY_MODAL = "SRE_HIDE_TOO_NOISY_MODAL";

export var SRE_SHOW_DISABLE_SPEECH_FOR_NOW_MODAL = "SRE_SHOW_DISABLE_SPEECH_FOR_NOW_MODAL";
export var SRE_HIDE_DISABLE_SPEECH_FOR_NOW_MODAL = "SRE_HIDE_DISABLE_SPEECH_FOR_NOW_MODAL";

export var SRE_SHOW_SUBMIT_REPORT_MODAL = "SRE_SHOW_SUBMIT_REPORT_MODAL";
export var SRE_HIDE_SUBMIT_REPORT_MODAL = "SRE_HIDE_SUBMIT_REPORT_MODAL";
export var SRE_INCREMENT_NUMBER_REPORTS_SUBMITTED = "SRE_INCREMENT_NUMBER_REPORTS_SUBMITTED";
export var SRE_RESET_NUMBER_REPORTS_SUBMITTED = "SRE_RESET_NUMBER_REPORTS_SUBMITTED";

export var SRE_DISABLE_SPEECH_FOR_NOW_MODAL_DISABLE_SPEECH_AFTER_ACTION = "SRE_DISABLE_SPEECH_FOR_NOW_MODAL_DISABLE_SPEECH_AFTER_ACTION";
export var SRE_AUDIO_QUALITY_MODAL_DISABLE_SPEECH_AFTER_ACTION = "SRE_AUDIO_QUALITY_MODAL_DISABLE_SPEECH_AFTER_ACTION";

var modalTypes = {
  silence: "silence",
  tooLoud: "tooLoud",
  tooSoft: "tooSoft",
  tooNoisy: "tooNoisy",
  disableSpeech: "disableSpeech",
  submitReport: "submitReport"
};

// intial state object
export var initialState = {
  audioQualityModals: {
    silence: {
      show: false
    },
    tooLoud: {
      show: false
    },
    tooSoft: {
      show: false
    },
    tooNoisy: {
      show: false
    },
    disableSpeech: {
      show: false
    },
    submitReport: {
      show: false,
      numberReportsSubmitted: 0
    }
  }
};

var toggleShowHideModalByType = function toggleShowHideModalByType(state, modalType, toggleState) {
  var _extends2;

  return _extends({}, state, {
    audioQualityModals: _extends({}, state.audioQualityModals, (_extends2 = {}, _extends2[modalType] = _extends({}, state.audioQualityModals[modalType], {
      show: toggleState
    }), _extends2))
  });
};

var reducer = function reducer() {
  var _extends3, _extends4;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  switch (action && action.type) {
    /*
      Silence Modal
     */
    case SRE_SHOW_SILENCE_MODAL:
      return toggleShowHideModalByType(state, modalTypes.silence, true);

    case SRE_HIDE_SILENCE_MODAL:
      return toggleShowHideModalByType(state, modalTypes.silence, false);

    /*
      Too Loud Modal
     */

    case SRE_SHOW_TOO_LOUD_MODAL:
      return toggleShowHideModalByType(state, modalTypes.tooLoud, true);

    case SRE_HIDE_TOO_LOUD_MODAL:
      return toggleShowHideModalByType(state, modalTypes.tooLoud, false);

    /*
      Too Soft Modal
     */

    case SRE_SHOW_TOO_SOFT_MODAL:
      return toggleShowHideModalByType(state, modalTypes.tooSoft, true);

    case SRE_HIDE_TOO_SOFT_MODAL:
      return toggleShowHideModalByType(state, modalTypes.tooSoft, false);

    /*
      Too Noisy Modal
     */

    case SRE_SHOW_TOO_NOISY_MODAL:
      return toggleShowHideModalByType(state, modalTypes.tooNoisy, true);

    case SRE_HIDE_TOO_NOISY_MODAL:
      return toggleShowHideModalByType(state, modalTypes.tooNoisy, false);

    /*
      Disable speech for now Modal - when user is getting many wrong in a row
     */

    case SRE_SHOW_DISABLE_SPEECH_FOR_NOW_MODAL:
      return toggleShowHideModalByType(state, modalTypes.disableSpeech, true);

    case SRE_HIDE_DISABLE_SPEECH_FOR_NOW_MODAL:
      return toggleShowHideModalByType(state, modalTypes.disableSpeech, false);

    /*
      Submit and "SRE REPORT" Modal - when user clicks flag on sre act that has happened repeatedly
     */

    case SRE_SHOW_SUBMIT_REPORT_MODAL:
      return toggleShowHideModalByType(state, modalTypes.submitReport, true);

    case SRE_HIDE_SUBMIT_REPORT_MODAL:
      return toggleShowHideModalByType(state, modalTypes.submitReport, false);

    // zoom for instance shows the disable speech modal after
    // 3 reports are submitted, so this keeps the count of the number
    // of times a user has submitted an SRE report
    case SRE_INCREMENT_NUMBER_REPORTS_SUBMITTED:
      return _extends({}, state, {
        audioQualityModals: _extends({}, state.audioQualityModals, (_extends3 = {}, _extends3[modalTypes.submitReport] = _extends({}, state.audioQualityModals[modalTypes.submitReport], {
          numberReportsSubmitted: state.audioQualityModals[modalTypes.submitReport].numberReportsSubmitted + 1
        }), _extends3))
      });

    case SRE_RESET_NUMBER_REPORTS_SUBMITTED:
      return _extends({}, state, {
        audioQualityModals: _extends({}, state.audioQualityModals, (_extends4 = {}, _extends4[modalTypes.submitReport] = _extends({}, state.audioQualityModals[modalTypes.submitReport], {
          numberReportsSubmitted: 0
        }), _extends4))
      });

    // pass through to issue redux action that a client-saga can catch
    // and use to send the form info to analytics
    // (will not manipulate anything in state.sre.audioQualityModals)
    // case SRE_SHOW_SUBMIT_REPORT_MODAL_SEND_TO_ANALYTICS:
    //   return state;

    default:
      return state;
  }
};

// Action Creators
export var actions = {
  // silence modal
  showSilenceModal: function showSilenceModal() {
    return { type: SRE_SHOW_SILENCE_MODAL };
  },
  hideSilenceModal: function hideSilenceModal() {
    return { type: SRE_HIDE_SILENCE_MODAL };
  },
  // too loud modal
  showTooLoudModal: function showTooLoudModal() {
    return { type: SRE_SHOW_TOO_LOUD_MODAL };
  },
  hideTooLoudModal: function hideTooLoudModal() {
    return { type: SRE_HIDE_TOO_LOUD_MODAL };
  },
  // too soft modal
  showTooSoftModal: function showTooSoftModal() {
    return { type: SRE_SHOW_TOO_SOFT_MODAL };
  },
  hideTooSoftModal: function hideTooSoftModal() {
    return { type: SRE_HIDE_TOO_SOFT_MODAL };
  },
  // too noisy modal
  showTooNoisyModal: function showTooNoisyModal() {
    return { type: SRE_SHOW_TOO_NOISY_MODAL };
  },
  hideTooNoisyModal: function hideTooNoisyModal() {
    return { type: SRE_HIDE_TOO_NOISY_MODAL };
  },
  // disable speech for now modal
  showDisableSpeechForNowModal: function showDisableSpeechForNowModal() {
    return { type: SRE_SHOW_DISABLE_SPEECH_FOR_NOW_MODAL };
  },
  hideDisableSpeechForNowModal: function hideDisableSpeechForNowModal() {
    return { type: SRE_HIDE_DISABLE_SPEECH_FOR_NOW_MODAL };
  },
  // Submit and "SRE REPORT" Modal
  showSRESubmitReportModal: function showSRESubmitReportModal() {
    return { type: SRE_SHOW_SUBMIT_REPORT_MODAL };
  },
  hideSRESubmitReportModal: function hideSRESubmitReportModal(_ref) {
    var _ref$shouldFireAfterA = _ref.shouldFireAfterAction,
        shouldFireAfterAction = _ref$shouldFireAfterA === undefined ? false : _ref$shouldFireAfterA;
    return {
      type: SRE_HIDE_SUBMIT_REPORT_MODAL,
      payload: { shouldFireAfterAction: shouldFireAfterAction }
    };
  },
  incrementNumberSRESubmitReports: function incrementNumberSRESubmitReports() {
    return { type: SRE_INCREMENT_NUMBER_REPORTS_SUBMITTED };
  },
  resetNumberSRESubmitReports: function resetNumberSRESubmitReports() {
    return { type: SRE_RESET_NUMBER_REPORTS_SUBMITTED };
  },
  // OPTIONAL callbacks for disabling speech in these 2 modals,
  // so that clients (e.g. zoom) can restart an act or something in the instance speech is disabled
  disableSpeechForNowModalDisableSpeechAfterAction: function disableSpeechForNowModalDisableSpeechAfterAction() {
    return {
      type: SRE_DISABLE_SPEECH_FOR_NOW_MODAL_DISABLE_SPEECH_AFTER_ACTION
    };
  },
  audioQualityModalDisableSpeechAfterAction: function audioQualityModalDisableSpeechAfterAction() {
    return { type: SRE_AUDIO_QUALITY_MODAL_DISABLE_SPEECH_AFTER_ACTION };
  }
};

// selectors
/* istanbul ignore next */var sreAudioQualityModalStateWrapper = function sreAudioQualityModalStateWrapper(selector) {
  return function (state) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return selector.apply(undefined, [state.sre.audioQualityModals].concat(args));
  };
};
export var sreAudioQualityModalSelectors = {
  showSilentModal: function showSilentModal(state) {
    return state.silence.show;
  },
  showTooLoudModal: function showTooLoudModal(state) {
    return state.tooLoud.show;
  },
  showTooSoftModal: function showTooSoftModal(state) {
    return state.tooSoft.show;
  },
  showTooNoisyModal: function showTooNoisyModal(state) {
    return state.tooNoisy.show;
  },
  showDisableSpeechForNowModal: function showDisableSpeechForNowModal(state) {
    return state.disableSpeech.show;
  },
  showSubmitReportModal: function showSubmitReportModal(state) {
    return state.submitReport.show;
  },
  submitReportModalCount: function submitReportModalCount(state) {
    return state.submitReport.numberReportsSubmitted;
  }
};
export var selectors = _extends({}, wrapSelectors(sreAudioQualityModalStateWrapper, sreAudioQualityModalSelectors));

export default reducer;